module.exports = __webpack_public_path__ + "static/media/arrow-dropdown-icon.6b20abee.svg";